import styles from './Header.module.css';
import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import apiService from '../services/api';

const menuData = [
  {
    title: "협회소개",
    href: "/about",
    submenu: null,
  },
  {
    title: "교육프로그램",
    href: "/program",
    submenu: null,
  },
  {
    title: "색채 컨설팅",
    href: "/consulting",
    submenu: null,
  },
  {
    title: "올해의 컬러",
    href: "/yearly-color",
    submenu: null,
  },
  {
    title: "기업 멤버쉽",
    href: "/membership",
    submenu: null,
  },
  {
    title: "NEWS",
    href: "/news",
    submenu: null,
  },
];


function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [navOpen, setNavOpen] = useState(false);
  const navRef = useRef(null);
  const hamburgerRef = useRef(null);

  const [show, setShow] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [userInfo, setUserInfo] = useState(null);

  // 검은색 헤더가 필요한 페이지 경로
  const darkHeaderPaths = ['/login', '/signup', '/yearly-color'];
  const isDarkHeader = darkHeaderPaths.includes(location.pathname) || location.pathname.startsWith('/admin');

  // 사용자 정보 로드
  useEffect(() => {
    const loadUserInfo = async () => {
      if (apiService.isUserAuthenticated()) {
        // 저장된 사용자 정보가 있으면 사용
        const storedInfo = apiService.getStoredUserInfo();
        if (storedInfo) {
          setUserInfo(storedInfo);
        } else {
          // 저장된 정보가 없으면 서버에서 가져오기
          try {
            const info = await apiService.getUserInfo();
            setUserInfo(info);
          } catch (error) {
            console.error('Failed to load user info:', error);
            // 로그인 만료 시 로그아웃 처리
            await apiService.logoutUser();
            setUserInfo(null);
          }
        }
      }
    };
    
    loadUserInfo();
  }, []);

  // 로그아웃 처리
  const handleLogout = async () => {
    try {
      await apiService.logoutUser();
      setUserInfo(null);
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setNavOpen(false);
      }
    };

    if (navOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [navOpen]);

  useEffect(() => {
    const controlHeader = () => {
      if (typeof window !== "undefined") {
        setScrolled(window.scrollY > 10);

        if (window.scrollY < lastScrollY || window.scrollY <= 0) {
          setShow(true);
        } else {
          setShow(false);
          setNavOpen(false);
        }

        setLastScrollY(window.scrollY < 0 ? 0 : window.scrollY);
      }
    };

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", controlHeader);

      return () => {
        window.removeEventListener("scroll", controlHeader);
      };
    }
  }, [lastScrollY]);

  return (
    <header
      className={`${styles.header} ${scrolled ? styles.scrolled : ""} ${show ? "" : styles.hidden} ${isDarkHeader ? styles.dark : ""}`}
    >
      <div className={styles.headerWrap}>
        <div className={styles.leftButtons}>
          <button
            ref={hamburgerRef}
            className={`${styles.hamburger} ${navOpen ? styles.active : ""
              }`}
            onClick={() => setNavOpen((v) => !v)}
            aria-label="메뉴 열기"
          >
            <span />
            <span />
            <span />
          </button>
          {userInfo ? (
            <div className={styles.userInfo}>
              <span className={styles.userName}>{userInfo.name} 회원님</span>
              <button onClick={handleLogout} className={styles.logoutButton}>
                로그아웃
              </button>
            </div>
          ) : (
            <Link to="/login" className={styles.loginButton}>
              <img src={isDarkHeader ? "/image/icon-login-btn-dark.png" : "/image/icon-login-btn.png"} alt="login" />
            </Link>
          )}
        </div>
          <h1 className={styles.logo}>
          <Link to="/">
            <span>한국감성색채협회</span>
            <img src={isDarkHeader ? "/image/logo.png" : "/image/logo-white.png"} alt="logo" />
          </Link>
        </h1>
        <div className={styles.rightButton}>
          <Link to="/member-guide" className={styles.membershipButton}>
            정회원 가입하기
          </Link>
        </div>
        <div
          ref={navRef}
          className={`${styles.navWrap} ${navOpen ? styles.active : ""
            }`}
        >
          <button
            className={styles.closeButton}
            onClick={() => setNavOpen(false)}
            aria-label="메뉴 닫기"
          >
            <img src="/image/icon-close-btn.png" alt="close" />
          </button>
          {/* 모바일용 유저 정보 */}
          {userInfo && (
            <div className={styles.mobileUserInfo}>
              <span className={styles.mobileUserName}>{userInfo.name} 회원님</span>
              <button onClick={handleLogout} className={styles.mobileLogoutButton}>
                로그아웃
              </button>
            </div>
          )}
{/*           {!userInfo && (
            <Link to="/login" className={styles.mobileLoginButton}>
              <img src={isDarkHeader ? "/image/icon-login-btn-dark.png" : "/image/icon-login-btn.png"} alt="login" />
            </Link>
          )} */}
          <nav className={styles.nav}>
            <ul className={styles.navflexBox}>
              {menuData.map((item) => (
                <li
                  key={item.title}
                  className={styles.menuItem}
                >
                  <Link
                    className={`${styles.menuTitleLink} ${styles.communityLink}`}
                    to={item.href}
                    onClick={() => {
                      setNavOpen(false);
                    }}
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}
export default Header;